import { render, staticRenderFns } from "./PostQAPanel.vue?vue&type=template&id=70619379&scoped=true"
import script from "./PostQAPanel.vue?vue&type=script&lang=js"
export * from "./PostQAPanel.vue?vue&type=script&lang=js"
import style0 from "./PostQAPanel.vue?vue&type=style&index=0&id=70619379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70619379",
  null
  
)

export default component.exports